'use strict';

(function () {
  'use strict';

  angular.module('msSleep', ['chart.js']).constant('STANDARD_DATE_FMT', 'YYYY-MM-DD');
})();